import type { IconSvgObject } from './types';

const LayoutThreeRowIcon: IconSvgObject = [
  ["path", { d: "M5.5 21.5H18.5C20.1569 21.5 21.5 20.1569 21.5 18.5V5.5C21.5 3.84315 20.1569 2.5 18.5 2.5H5.5C3.84315 2.5 2.5 3.84315 2.5 5.5V18.5C2.5 20.1569 3.84315 21.5 5.5 21.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.5 8.5H2.5", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21.5 15.5H2.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default LayoutThreeRowIcon;
